export default {
  data() {
    return {
      menuVisible: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      // this.$refs.burger.classList.toggle('menu-open');
      document.documentElement.classList.toggle('overflow-hidden');
      document.body.classList.toggle('overflow-hidden');
    },
  },
  render() {
    return this.$scopedSlots.default({
      menuVisible: this.menuVisible,
      toggleMenu: this.toggleMenu,
    });
  },
};
